export const ADD_NOTICE = 'ADD_NOTICE';
